import React from "react";
import {BsPlayCircle } from "react-icons/bs"; 
import ReactPlayer from "react-player";
import { onboarding_WELCOME_VIDEO } from "utils/constant";


const VideoGuide = ({
  showText=false, 
  className='w-full h-[44vh]',
  setCompleteTab = ()=>{},
  setEanbleBtn = () =>{},
  getVerified = false,
  vidLink = onboarding_WELCOME_VIDEO,
  fullPlay = true,
  activateAudio = true,
  preview = true,
  currentTab = null
})=>{

  const [video, setVideos] = React.useState({
    url:onboarding_WELCOME_VIDEO
  });
  const playerRef = React.useRef(null); 
  const [isPreviewing, setIsPreviewing] =React.useState(fullPlay);
  // const [isPlayingFull, setIsPlayingFull] = React.useState(fullPlay);
  const [mute, setMute] = React.useState(true);

  const handlePlayFull = () => {
    setMute(false)
    setIsPreviewing(false);
    // setIsPlayingFull(true);
    playerRef.current.seekTo(0);
  };

 React.useEffect(()=>{
    setVideos((prev)=>({...prev,url:vidLink}));
 },[vidLink])

React.useEffect(()=>{
      if(currentTab === 'videoGuide'){
        setMute(true);
        setIsPreviewing(false);
        // setIsPlayingFull(false);
        return
      }
      setMute(false)
      setIsPreviewing(true);
      // setIsPlayingFull(true);
      playerRef.current.seekTo(0);
 },[video.url,currentTab])


  const handleProgress = (progress) => {
    // if (isPreviewing && progress.playedSeconds >= 5) {
    //   playerRef.current.seekTo(0);
    // }
    if(progress.playedSeconds >= 8 && progress.playedSeconds <=10){ 
        if(getVerified){ 
          setCompleteTab((prev)=>[...prev,'videoGuide']);
          setEanbleBtn((prev)=>[...prev,'videoGuide']);
        }
    }
  };

  const onEndPlaying = ()=>{
    // setIsPlayingFull(false);
    playerRef.current.seekTo(0); // Reset to start
    setMute(false)
    setIsPreviewing(false);
  }

  const togglePlayPause = () => {
    setIsPreviewing(prev => !prev); // Toggle playing state
    setMute(false)

  };
    return (
        video?.url ? (
            <div className={`bg-white z-[9999] flex flex-col ${className}`}>
            {/* Video Section */}
            <div className="relative flex-1 px-2 flex items-center justify-center">
              <div className="relative w-full pt-[56.25%]"> {/* 16:9 Aspect Ratio */}
                <ReactPlayer
                  ref={playerRef}
                  url={video?.url}
                  playing={isPreviewing}
                  muted={mute}
                  loop={false}
                  controls={false}
                  onProgress={handleProgress}
                  onEnded={onEndPlaying}
                  width="100%"
                  height="100%"
                  className="absolute top-0 left-0"
                />
                <div className="absolute inset-0 cursor-pointer z-[999]"
                  onClick={togglePlayPause}
                ></div>
              </div>

              {!isPreviewing && (
                <div className="absolute z-10 cursor-pointer" >
                  <div className="flex flex-col w-full items-center justify-center">
                    <BsPlayCircle className="text-white text-6xl opacity-80 hover:opacity-100 transition-opacity" />
                    {/* {showText && <div className="text-white font-bold">Build your profile in 2 minutes</div>} */}
                  </div>
                </div>
              )}
            </div>
          </div>

        ):
        <></>
    );
  
}

export default VideoGuide;